module.exports = __webpack_public_path__ + "kaitak-ogp-220123.f4d8f8175cfb8152fc82.jpg";